import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useGetLayoutScreens } from 'src/hooks';
import { getScreenName } from 'src/hooks/api/layouts/helpers';
import { useGlobalComponentsScreen } from 'src/hooks/useGlobalComponentsScreen';

import { restoreLayoutDraft } from '../editLayoutsPage.utils';

export const useEditLayoutsPage = (layoutId?: number) => {
  const {
    data: layouts = [],
    isLoading: isLayoutScreensLoading,
    isFetching: isLayoutScreensFetching,
  } = useGetLayoutScreens(layoutId, Boolean(layoutId));
  const globalComponentsScreen = useGlobalComponentsScreen(layouts?.[0]);

  const formMethods = useForm({
    mode: 'onChange',
  });

  const canSaveAsDraft = isEmpty(formMethods.formState.errors);

  const screensWithTakeover = layouts?.[0]?.screens.reduce(
    (indices, screen, index) => {
      if (
        screen.sections.some(
          (section) => section.config?.events?.LAYOUT_TIMER !== undefined,
        )
      ) {
        indices.push(index);
      }

      return indices;
    },
    [] as number[],
  );

  const screenNames = layouts?.[0]?.screens?.map((screen, index) => {
    return (
      (layouts?.[0]?.layoutType &&
        getScreenName(
          layouts?.[0]?.layoutType,
          layouts?.[0]?.cod_position,
          index + 1,
          layouts?.[0]?.screens?.length,
          layouts?.[0]?.config?.screenLayoutType,
        )) ||
      ''
    );
  });

  const sidebarScreenOrder = Array.from(
    { length: layouts?.[0]?.screens?.length ?? 0 },
    (_, index) => index,
  );

  useEffect(() => {
    if (layouts && layouts?.[0] && layouts?.[0]?.name) {
      const values: any = {
        name: layouts[0].name,
        layout_duration: '1s',
      };

      layouts[0]?.screens?.forEach((screen, idx) => {
        values[`screen_${idx}`] = screen.sections.some(
          (section) => section.config?.events?.LAYOUT_TIMER !== undefined,
        );
      });

      formMethods.reset(values);

      // Re-apply any changes stashed when the user stepped into the
      // section-creation page so edits (e.g. the layout name) are not lost.
      restoreLayoutDraft(layoutId, formMethods);
    }
  }, [layouts, formMethods, layoutId]);

  return {
    layouts,
    canSaveAsDraft,
    screenNames,
    sidebarScreenOrder,
    isLayoutScreensLoading,
    isLayoutScreensFetching,
    formMethods,
    screensWithTakeover,
    globalComponentsScreen,
  };
};
